import { render, staticRenderFns } from "./OsobeListReport.vue?vue&type=template&id=0a622764"
import script from "./OsobeListReport.vue?vue&type=script&lang=js"
export * from "./OsobeListReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports